import script from "./AulasView.vue?vue&type=script&setup=true&lang=js"
export * from "./AulasView.vue?vue&type=script&setup=true&lang=js"

import "./AulasView.vue?vue&type=style&index=0&id=79972696&lang=css"

const __exports__ = script;

export default __exports__